export default {"src":"/_next/static/media/checklist.ba25319e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};